import Vue from "vue";
import Router from "vue-router";
import routes from "./router/routes";
import axios from "axios";
import store from "./store";
//import About from "./views/About";
//import Faq from "./views/Faq";
import Sales from "./views/Sales";
import Post from "./views/Post";
import Terms from "./views/Terms";
import Career from "./views/Career";
import Delivery from "./views/Delivery";
import NotFound from "./views/404";
import CostumerService from "./views/CostumerService";
import EditOrder from "./views/EditOrder";
import PermPageNew from "./views/PermPageNew";
import B2bLeadForm from "./views/B2bLeadForm";
import LP from "./views/LP";
import RemoveUser from "./views/RemoveUser";
import Page from "./views/Page";
import ClubMembers from "./views/ClubMembers";
import BusinessLP from "./views/BusinessLP";
import { Store } from "vuex";

Vue.use(Router);
/** /clients/carmellavue  prod */
/** /carmella/  dev */
const router = new Router({
	mode: "history",
	base: baseSlug,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			if (to.params.noScroll) {
				resolve();
			}
			if (to.fullPath == from.fullPath) {
				resolve();
			}
			if (
				typeof to.params.cat != "undefined" &&
				typeof from.params.cat != "undefined" &&
				to.params.cat == from.params.cat
			) {
				setTimeout(() => {
					resolve({ x: 0, y: window.topLocation });
				}, 200);
			} else {
				setTimeout(() => {
					resolve({ x: 0, y: 0 });
				}, 200);
				// reject();
			}
		});
	},
});

function getComponent(name) {
	let component = null;
	switch (name) {
		case "About":
			//component = About;
			component = () => import("./views/About");
			break;
		case "Career":
			component = Career;
			break;
		case "Delivery":
			component = Delivery;
			break;
		case "Faq":
			component = () => import("./views/Faq");
			break;
		case "Sales":
			component = Sales;
			break;
		case "Terms":
			component = Terms;
			break;
		case "CostumerService":
			component = CostumerService;
			break;
		case "EditOrder":
			component = EditOrder;
			break;
		case "Post":
			component = Post;
			break;
		case "PermPageNew":
			component = PermPageNew;
			break;
		case "B2bLeadForm":
			component = B2bLeadForm;
			break;
		case "LP":
			component = LP;
			break;
		case "RemoveUser":
			component = RemoveUser;
			break;
		case "ClubMembers":
			component = ClubMembers;
			break;
		case "Page":
			component = Page;
			break;
		case "BusinessLP":
			// loading like this has noticeable effect
			//component = () => import("./views/BusinessLP");
			component = BusinessLP;
			break;
	}
	return component;
}

for (var key in wpData.routes) {
	var routeItem = wpData.routes[key];

	router.addRoutes([
		{
			path: decodeURI(routeItem.path),
			name: routeItem.name,
			component: getComponent(routeItem.component),
			props: {
				defualt: true,
				// postId: route.props.taxonomy_id
			},
		},
		{
			path: routeItem.path,
			name: routeItem.name,
			component: getComponent(routeItem.component),
			props: {
				defualt: true,
				// postId: route.props.taxonomy_id
			},
		},
	]);
}
router.addRoutes([
	{
		path: "*",
		name: "not-found",
		component: NotFound,
		props: {
			defualt: true,
			// postId: route.props.taxonomy_id
		},
	},
]);

var savedRoute = "";


router.beforeEach((to, from, next) => {
	$(".ui-tooltil").hide();
	$("#mm-blocker").trigger("mousedown");

	if (to.name == "checkout" && from.name && from.name != "permenent") {
		store.commit("setPermOrderEdit", false);
	}
	let route_path = to.path.split("/");
	let is_product = route_path[1] == "product" ? true : false;
	store.commit("sentCart", false);

	if (to.name == "lost-password") {
		axios({
			method: "POST",
			url: homeUrl + "?ValidateReset",
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Content-Type": "text/html",
				charset: "utf-8",
			},
			params: {
				reset_key: to.query.key,
				reset_login: to.query.id,
			},
		})
			.then((res) => {
				if (res.data.success) {
					next();
					return;
				}
				// if(!res.data.success){
				//   next('/');
				//   return;
				// }
			})
			.catch((e) => console.log(e));
	}

	if (to.query.s && store.state.searchResultProducts.length === 0) {
		axios({
			method: "POST",
			url: homeUrl + "ajax.php",
			params: {
				search: to.query.s,
			},
		})
			.then((res) => {
				store.state.products = [];
				store.commit("setProducts", res.data);
				//store.state.products = res.data;
				next();
			})
			.catch((e) => {
				next();
			});

		return;
	}

	if (to.name == "product") {
		if (wpData.startPage == true) {
			wpData.startPage = false;
		}
		let slug = to.params.product;
		let product = "";

		axios({
			method: "POST",
			url: homeUrl + "ajax.php",
			params: {
				getProductbySlug: "",
				slug: slug,
			},
		})
			.then((res) => {
				product = res.data;

				// open product popup
				store.dispatch("openPopupProduct", [product]).then(() => {
					Vue.prototype.$modal.show("prod-modal");
				});

				// unknown porpuse
				let categories = res.data.categories;
				let cat = "";
				let child_cat = "";
				categories.map((id) => {
					let category = store.state.categories.find((c) => c.id == id);
					if (typeof category != "undefined" && category.parent == 0) {
						cat = category;
					}
					if (typeof category != "undefined" && category.parent != 0) {
						child_cat = category;
					}
				});

				axios({
					method: "POST",
					url: homeUrl + "ajax.php",
					params: {
						slug: cat.slug,
					},
				})
					.then((res) => {
						store.state.products = [];

						//store.commit("setProducts", res.data);
						store.commit("setCategoriesProducts", res.data);
						store.commit("setStartProduct", product);
						store.commit("setStartCategory", child_cat);
						//store.state.products = res.data;
						next();
					})
					.catch((e) => {
						next();
					});
				return;
			})
			.catch((e) => {
				console.log(e);
			});
	}

	if (to.name == "history") {
		if (wpData.startPage == true) {
			wpData.startPage = false;
			next();
			return;
		}
		next();
		return;
	}

	if (to.name == "checkout") {
		if (from.name && from.name != "permenent") {
			store.commit("setPremenantOrder", false);
		}
		// Disable send cart action on checkout routing

		// store.commit("sentCart", false);
		// let formData = new FormData();
		// formData.append("action", "sendCart");
		// formData.append("products", store.getters.cartJSON);
		// axios({
		// 	method: "POST",
		// 	headers: {
		// 		"X-Requested-With": "XMLHttpRequest",
		// 		"Content-Type": "text/html",
		// 		charset: "utf-8",
		// 	},
		// 	url: ajaxUrl + "?action=sendCart",
		// 	data: formData,
		// })
		// 	.then((res) => {
		// 		store.commit("sentCart", true);
		// 	})
		// 	.catch((e) => console.log(e));
	}

	if (to.name == "checkout" || to.name == "myaccount" || to.name == "history" || to.name == "cashback" || to.name == "userhome") {
		if (wpData.startPage == true) {
			wpData.startPage = false;
		}
		if (!store.getters.userCheckoutInfo) {
			axios({
				method: "GET",
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"Content-Type": "text/html",
					charset: "utf-8",
				},
				url: ajaxUrl + "?action=isUserLogged",
			})
				.then((resposne) => {
					if (resposne.data.success) {
						var user = resposne.data.data;
						store.commit("setUserInfo", user);
					} else {
						store.commit("clearUser");
					}
				})
				.catch((e) => console.log(e));
		}
	}

	if (
		to.name != "checkout" &&
		to.name != "subcategory" &&
		to.name != "category" &&
		to.name != "myaccount" &&
		to.name != "userhome" &&
		to.name != "orderEnter" &&
		to.name != "product" &&
		to.name != "permenent"
	) {
		if (wpData.startPage == true) {
			wpData.startPage = false;
			next();
			return;
		}

		if (to.path.includes('/?s=')) {
			next();
			return;
		}

		let getFileSlug = to.path;

		if (
			[
				"blog",
				"blog-posts-main-page",
				"blog-posts-by-tag",
				"blog-posts-by-tag-page",
				"blog-posts-by-cat",
				"blog-posts-by-cat-page",
			].includes(to.name)
		) {
			getFileSlug = "מתכונים";
		}

		getFileSlug = getFileSlug.replace(/^\/|\/$/g, "");
		if (getFileSlug == "") {
			getFileSlug = "index";
		}
		getFileSlug = getFileSlug.toLowerCase() + ".json";

		if ([
			"gift-card/purchase.json",
			"gift-card/send.json",
			"gift-card/pay.json",
			"product-recommendations.json"
		].includes(getFileSlug)) {
			next();
			return;
		}

		// update pageData in wpData (acf fields)
		axios
			.get(cacheFolder + getFileSlug)
			.then((res) => {
				wpData.pageData = res.data;
				next();
			})
			.catch((e) => {
				console.log("[vue-router]", "trying to load: ", "\n >>", getFileSlug);
				next();
			});
		return;
	}
	// if (to.name == "subcategory" || to.name == "category") {

	if ($(window).width() < 800) {
		if (to.name == "subcategory" || to.params.cat != from.params.cat) {
			if (wpData.startPage == true) {
				wpData.startPage = false;
				// store.state.products = JSON.parse(wpData.categoryData);
				store.commit("setProducts", []);
				store.dispatch("setAjaxProducts", wpData.categoryData);
				next();
				return;
			}
			//return;
			let getFileSlug = to.path;
			getFileSlug = getFileSlug.replace(/^\/|\/$/g, "");
			if (getFileSlug == "") {
				getFileSlug = "index";
			}
			next();
			axios({
				method: "GET",
				url: cache_url + "categories/" + to.params.cat + ".json",
			})
				.then((res) => {
					store.state.products = [];
					store.commit("setCategoriesProducts", res.data);
				})
				.catch((e) => {
					next();
				});
			return;
		}
	}

	if (to.name == "subcategory" && !from.name) {
		if (wpData.startPage == true) {
			wpData.startPage = false;
			// store.state.products = JSON.parse(wpData.categoryData);

			//store.commit("setCategoriesProducts", JSON.parse(wpData.categoryData));
			store.commit("setProducts", []);
			store.dispatch("setAjaxProducts", wpData.categoryData);
			next();
			return;
		}
		//return;
		store.commit("setProducts", []);
		let getFileSlug = to.path;
		getFileSlug = getFileSlug.replace(/^\/|\/$/g, "");
		if (getFileSlug == "") {
			getFileSlug = "index";
		}
		next();
		axios({
			method: "POST",
			url: homeUrl + "ajax.php",
			params: {
				slug: to.params.cat,
			},
		})
			.then((res) => {
				store.state.products = [];
				store.commit("setProducts", res.data);
				//store.state.products = res.data;
				next();
			})
			.catch((e) => {
				next();
			});

		return;
	}
	if (to.name == "category" || to.params.cat != from.params.cat) {
		if (wpData.startPage == true) {
			wpData.startPage = false;
			// store.state.products = JSON.parse(wpData.categoryData);
			//console.log(JSON.parse(wpData.categoryData));

			//store.commit("setCategoriesProducts", JSON.parse(wpData.categoryData));

			store.commit("setProducts", []);
			store.dispatch("setAjaxProducts", wpData.categoryData);
			next();
			return;
		}
		//return;
		store.commit("setProducts", []);
		let getFileSlug = to.path;
		getFileSlug = getFileSlug.replace(/^\/|\/$/g, "");
		if (getFileSlug == "") {
			getFileSlug = "index";
		}
		next();
		axios({
			method: "GET",
			//url: homeUrl + "ajax.php",
			url: cache_url + "categories/" + to.params.cat + ".json",
			// params: {
			//   slug: to.params.cat
			// }
		})
			.then((res) => {
				console.log(res);
				store.state.products = [];
				// let response = Object.values(res.data);
				//
				// let allproducts = [];
				// response.forEach((element) => {
				// 	allproducts = [...allproducts, ...element];
				// });
				// console.log(allproducts);

				store.commit("setCategoriesProducts", res.data);
				//store.commit("setProducts", allproducts);
				//store.state.products = res.data;
				// next();
			})
			.catch((e) => {
				next();
			});
		return;
	}
	if (to.name == "thank-you") {
		store.dispatch('resetCashbackPoints');
	}


	if (!to.path.endsWith("/")) {
		next({ path: `${to.path}/`, query: to.query, hash: to.hash });
	} else {
		next();
	}
});

// router.beforeResolve((to, from, next) => {
//   console.log("beforeResolve");
//   next();
// });

router.afterEach((to, from) => {
	//NProgress.done();
	let classLists = [];

	classLists["home"] = "page-template-home";
	classLists["category_sales"] = "page-template-sales";
	classLists["category"] = "archive tax-product_cat woocommerce woocommerce-page";
	classLists["subcategory"] = "archive tax-product_cat woocommerce woocommerce-page";
	classLists["checkout"] = "woocommerce-checkout woocommerce-page";
	classLists["checkout-permenent"] = "woocommerce-checkout woocommerce-page";
	classLists["orderEnter"] = "woocommerce-checkout woocommerce-page";
	classLists["about"] = "page-template-about";
	classLists["password-reset"] = "page-template-reset";
	classLists["myaccount"] = "page-template-my_permanent";
	classLists["permenent"] = "page-template-my_permanent";
	classLists["cashback"] = "page-template-cashback";
	classLists["contact"] = "page-template-contact";

	$("#app").removeClass("cat-black");
	if (to.name === "lost-password") {
		var body = document.getElementsByTagName("body");
		body[0].classList.remove("error404");
	}
	if (typeof classLists[to.name] != "undefined") {
		var body = document.getElementsByTagName("body");
		setTimeout(function () {
			if (document.querySelector("#wpadminbar") !== null) {
				body[0].className = classLists[to.name] + " admin-bar";
			} else {
				body[0].className = classLists[to.name];
			}
		}, 500);
		//body[0].classList.add("woocommerce-checkout");
	}
	if (from.name == "thank-you") {
		var body = document.getElementsByTagName("body");
		body[0].classList.remove("woocommerce-checkout");
		store.dispatch('resetCashbackPoints');
	}
	if (from.name) {
	}
	setTimeout(() => {
		if (jQuery(".wpcf7-form").length > 0 && jQuery(".wpcf7-form .submit_bt .ajax-loader").length == 0) {
			wpcf7.initForm(jQuery(".wpcf7-form"));
		}
	}, 1000);
});
export default router;
